'use client';

import React, { useMemo } from 'react';
import {
  RefinementList,
  Index,
  Configure,
  // eslint-disable-next-line import/no-unresolved
} from 'react-instantsearch-next';
import DesktopProductListingSidebarContainer from 'components/consumer/ProductListingPage/components/desktop/DesktopProductListingSidebarContainer';
import { ALGOLIA_INDEX_NAME, ALGOLIA_PRODUCT_INDEXES } from 'commons/constants';
import QuickShipFilter from 'components/essentials/ConsumerFilters/components/QuickShipFilter';
import removeQuickshipFacet from '../../../advanced-search/helpers/removeQuickshipFacet';
import useAdvancedSearchContext from '../../hooks/useAdvancedSearchContext';
import SectionButtons from './components/SectionButtons';
import WidthRangeFilter from '../WidthRangeFilter';
import ClearAllFiltersButtonComponent from '../ClearAllFiltersButton';

const AdvancedSearchSidebar = () => {
  const {
    currentSearchSection,
    updateSearchSection,
    isReadyToShipActive,
    handleToggleReadyToShip,
  } = useAdvancedSearchContext();

  const facetFilters = useMemo(
    () => (isReadyToShipActive ? ['is_in_stock:true'] : []),
    [isReadyToShipActive]
  );

  const sanitizedFacetFilters = useMemo(
    () => removeQuickshipFacet(facetFilters),
    [facetFilters]
  );

  return (
    <DesktopProductListingSidebarContainer isOpen>
      <h2 className="text-base font-bold text-gray px-0 py-4">Refine by:</h2>
      <SectionButtons
        title="Products"
        onClick={() => updateSearchSection?.(ALGOLIA_INDEX_NAME.PRODUCTS)}
        active={currentSearchSection === ALGOLIA_INDEX_NAME.PRODUCTS}
      />
      <Index indexName={ALGOLIA_INDEX_NAME.CUSTOMER_PHOTOS}>
        <Configure
          facets={['*']}
          numericFilters=""
          facetFilters={sanitizedFacetFilters}
        />
        <SectionButtons
          title="Customer Photos"
          onClick={() =>
            updateSearchSection?.(ALGOLIA_INDEX_NAME.CUSTOMER_PHOTOS)
          }
          active={currentSearchSection === ALGOLIA_INDEX_NAME.CUSTOMER_PHOTOS}
        />
      </Index>
      <Index indexName={ALGOLIA_INDEX_NAME.REVIEWS}>
        <Configure facets={['*']} numericFilters="" facetFilters="" />
        <SectionButtons
          title="Reviews"
          onClick={() => updateSearchSection?.(ALGOLIA_INDEX_NAME.REVIEWS)}
          active={currentSearchSection === ALGOLIA_INDEX_NAME.REVIEWS}
        />
      </Index>
      <Index indexName={ALGOLIA_INDEX_NAME.STATIC_PAGES}>
        <Configure
          numericFilters={['is_active=1', 'show_in_search=1', 'fk_store_id=1']}
        />
        <SectionButtons
          title="Pages"
          onClick={() => updateSearchSection?.(ALGOLIA_INDEX_NAME.STATIC_PAGES)}
          active={currentSearchSection === ALGOLIA_INDEX_NAME.STATIC_PAGES}
        />
      </Index>
      {/* not only covers products_jb4 but also other indexes with alternate sort order applied */}
      {ALGOLIA_PRODUCT_INDEXES.includes(currentSearchSection) && (
        <>
          <div className="mt-4">
            <ClearAllFiltersButtonComponent />
          </div>
          <div className="mt-4">
            <QuickShipFilter
              isChecked={isReadyToShipActive}
              onChange={handleToggleReadyToShip}
              minHeight={false}
              withLocation
            />
          </div>
          <div className="mt-4">
            <WidthRangeFilter showTitle />
          </div>
          <div>
            <h3 className="text-base font-bold mb-2 mt-4">Product Type</h3>
            <RefinementList
              attribute="type"
              limit={10}
              showMore
              classNames={{
                item: 'cursor-pointer',
                label: 'group flex relative cursor-pointer mt-4',
                checkbox: 'group-hover:cursor-pointer mt-1',
                labelText:
                  '[&_a]:text-brand [&_a]:z-[2] [&_a]:focus:underline group-hover:cursor-pointer text-gray pl-4 text-sm mt-px group-hover:text-brand',
                count: 'hidden',
                showMore: 'text-sm font-bold text-brand mt-3',
              }}
            />
          </div>
        </>
      )}
    </DesktopProductListingSidebarContainer>
  );
};

export default AdvancedSearchSidebar;
